import { render, staticRenderFns } from "./DraftList.vue?vue&type=template&id=5fa48307&scoped=true&"
import script from "./DraftList.vue?vue&type=script&lang=js&"
export * from "./DraftList.vue?vue&type=script&lang=js&"
import style0 from "./DraftList.vue?vue&type=style&index=0&id=5fa48307&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa48307",
  null
  
)

export default component.exports